export default __webpack_public_path__ + "static/media/db_mail_icon.853be7a0.svg";